import config from './config';
import swal from 'sweetalert';
import axios from 'axios';
import localforage from 'localforage';

const {API_URL, homepage} = config;

const encodeQueryData = (data) => {
  const ret = [];
  for (let d in data) {
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  }
  return ret.join('&');
};

const Api = {
  get: (url, data) => {
    return Api.connect('GET', url, data, false);
  },
  post: (url, data, formData) => {
    return Api.connect('POST', url, data, formData);
  },

  connect: async (method, url, data, formData = false) => {
    try {
      let headers = null;
      if (formData === false) {
        headers = {
          'Content-Type': 'application/json',
        };
      } else {
        headers = {
          'Content-Type': 'multipart/form-data',
        };
      }

      const request = {
        method,
        headers,
      };

      if (data) {
        if (method === 'GET') {
          url += `?${encodeQueryData(data)}`;
        } else {
          if (formData === false) {
            request.data = JSON.stringify(data);
          } else {
            request.data = data;
          }
        }
      }

      const token = await localforage.getItem('token');
      if (token) {
        request.headers.Authorization = `Bearer ${token}`;
      }

      const responseJson = await axios(API_URL + url, request);

      if (responseJson) {
        if (responseJson.data) {
          if (responseJson.data.message) {
            swal({
              text: responseJson.data.message,
              icon: 'info',
              button: 'close',
            });
          }
        }
      }

      return responseJson.data;
    } catch (e) {
      if (e) {
        if (e.response) {
          if (e.response.status !== 200) {
            if (e.response.status === 403) {
              swal({
                title: 'Error!',
                text: 'Anda tidak memiliki hak akses',
                icon: 'error',
                button: 'close',
              });
            }
            if (e.response.status === 401) {
              await localforage.clear();
              swal({
                title: 'Info!',
                text: 'Silahkan login kembali',
                icon: 'info',
                button: 'close',
              }).then(() => (window.location.href = '/' + homepage));
            }
          }
        } else {
          swal({
            title: String(e),
            text: null,
            icon: 'error',
            button: 'close',
          });
        }
      } else {
        swal({
          title: String(e),
          text: null,
          icon: 'error',
          button: 'close',
        });
      }
    }
  },
};

export default Api;
